var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkspaceCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_23808",
    "data-name": "Group 23808",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.525,
    height: 31.391,
    viewBox: "0 0 30.525 31.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-1584953"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3722",
    "data-name": "Rectangle 3722",
    width: 30.525,
    height: 31.391,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23791",
    "data-name": "Group 23791",
    clipPath: "url(#clip-path-1584953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22165",
    "data-name": "Path 22165",
    d: "M26.334,14.354h0V6.437A3.445,3.445,0,0,0,22.912,3h-.426V2.465a2.431,2.431,0,1,0-4.862,0V3H8.711V2.465a2.465,2.465,0,1,0-4.929,0V3H3.413A3.437,3.437,0,0,0,0,6.437V24.616a3.437,3.437,0,0,0,3.413,3.437H14.122a9.277,9.277,0,1,0,12.213-13.7M1.35,6.437A2.085,2.085,0,0,1,3.413,4.352h.368V5.8a.66.66,0,0,0,.684.647H8.019A.666.666,0,0,0,8.711,5.8V4.352h8.913V5.8a.629.629,0,0,0,.611.647h3.59a.639.639,0,0,0,.66-.618c0-.01,0-.02,0-.03V4.352h.426a2.093,2.093,0,0,1,2.072,2.085V8.606H1.35V6.437M3.413,26.7A2.085,2.085,0,0,1,1.35,24.616V9.956H24.984V13.62A9.285,9.285,0,0,0,13.187,26.7ZM21.25,30.028a7.92,7.92,0,1,1,7.92-7.92h0a7.929,7.929,0,0,1-7.92,7.92",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22166",
    "data-name": "Path 22166",
    d: "M302.309,262.016H299.35v-4.063a.675.675,0,1,0-1.35,0v4.738a.687.687,0,0,0,.688.676h3.621a.675.675,0,0,0,0-1.35",
    transform: "translate(-277.878 -239.905)",
    fill: "#5e8dfa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceCalendarIcon);
export default __webpack_public_path__ + "static/media/workspace-calendar-icon.c2bcb5a9ff287797ed6a7566b3cfb7b9.svg";
export { ForwardRef as ReactComponent };